var map = {
	"./de-CH.json": [
		"c776"
	],
	"./emails/de-CH.json": [
		"3bad",
		"lang-emails-de-CH-json"
	],
	"./emails/en.json": [
		"ea69",
		"lang-emails-en-json"
	],
	"./en.json": [
		"edd4",
		"lang-en-json"
	],
	"./glossary/de-CH.json": [
		"6431"
	],
	"./glossary/en.json": [
		"c538"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "39c3";
module.exports = webpackAsyncContext;